import classNames from 'classnames';
import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import tabStyles from 'react-tabs/style/react-tabs.css';

import Box from '../box/box.jsx';
import CostumePanel from '../../containers/costume-panel.jsx';
import SoundPanel from '../../containers/sound-panel.jsx';
import Modal from '../modal/modal.jsx';

import styles from './asset-modal.css';
import {VM} from '@hetao/scratch-core';

import {getHomeworkInfo} from '../../lib/homework-info';

class LibraryComponent extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleActiveTab',
            'handleActiveCostumeTab',
            'handleActiveSoundTab'
        ]);

        this.state = {
            tabIndex: 0
        };
    }
    componentDidMount () {
        this.homeworkInfo = getHomeworkInfo();
        this.courseId = Number(this.homeworkInfo.courseId);
        this.unitId = Number(this.homeworkInfo.unitId);
        this.lessonId = Number(this.homeworkInfo.lessonId);
    }
    handleActiveTab (tab) {
        this.setState({
            tabIndex: tab
        });
    }

    handleActiveCostumeTab () {
        this.handleActiveTab(0);
        const editingTarget = this.props.vm.editingTarget;
        const id = editingTarget.id;
        const name = editingTarget.sprite.name;
        const category = editingTarget.isStage ? 'stage' : 'sprite';
        const tab0 = editingTarget.isStage ? 'backdrops' : 'costumes';

        const param = editingTarget.isStage ? {stage: {id: id, name: name}} : {sprite: {id: id, name: name}};
        ht.track(`s3_${category}_config_${tab0}`, {
            context: {
                courseId: this.courseId,
                unitId: this.unitId,
                lessonId: this.lessonId,
                currentUrl: location.href,
                stageDisplayMode: localStorage.getItem('stageDisplayMode')
            },
            param: param

        });
    }

    handleActiveSoundTab () {
        const editingTarget = this.props.vm.editingTarget;
        const id = editingTarget.id;
        const name = editingTarget.sprite.name;
        const category = editingTarget.isStage ? 'stage' : 'sprite';
        const param = editingTarget.isStage ? {stage: {id: id, name: name}} : {sprite: {id: id, name: name}};
        ht.track(`s3_${category}_config_sounds`, {
            context: {
                courseId: this.courseId,
                unitId: this.unitId,
                lessonId: this.lessonId,
                currentUrl: location.href,
                stageDisplayMode: localStorage.getItem('stageDisplayMode')
            },
            param: param

        });
        this.handleActiveTab(1);
    }

    render () {
        const tabClassNames = {
            tabs: styles.tabs,
            tab: classNames(styles.tab),
            tabList: classNames(tabStyles.reactTabsTabList, styles.tabList),
            tabPanel: classNames(tabStyles.reactTabsTabPanel, styles.tabPanel),
            tabPanelSelected: classNames(tabStyles.reactTabsTabPanelSelected, styles.isSelected),
            tabSelected: classNames(tabStyles.reactTabsTabSelected, styles.isSelected)
        };

        const isStage = this.props.vm.editingTarget.isStage;

        return (
            <Modal
                isOpen
                className={styles.modalContent}
                id={this.props.id}
                overlayClassName={styles.modalOverlay}
                onRequestClose={this.props.onRequestClose}
            >
                <Box className={styles.editorWrapper}>
                    <Tabs
                        forceRenderTabPanel
                        className={tabClassNames.tabs}
                        selectedIndex={this.state.tabIndex}
                        selectedTabClassName={tabClassNames.tabSelected}
                        selectedTabPanelClassName={tabClassNames.tabPanelSelected}
                        onSelect={this.handleActiveTab}
                    >
                        <TabList className={tabClassNames.tabList}>
                            <Tab
                                className={tabClassNames.tab}
                                onClick={this.handleActiveCostumeTab}
                            >
                                {isStage ? (
                                    <FormattedMessage
                                        defaultMessage="Backdrops"
                                        description="Button to get to the backdrops panel"
                                        id="gui.gui.backdropsTab"
                                    />
                                ) : (
                                    <FormattedMessage
                                        defaultMessage="Costumes"
                                        description="Button to get to the costumes panel"
                                        id="gui.gui.costumesTab"
                                    />
                                )}
                            </Tab>
                            <Tab
                                className={tabClassNames.tab}
                                onClick={this.handleActiveSoundTab}
                            >
                                <FormattedMessage
                                    defaultMessage="Sounds"
                                    description="Button to get to the sounds panel"
                                    id="gui.gui.soundsTab"
                                />
                            </Tab>
                        </TabList>
                        <TabPanel className={tabClassNames.tabPanel}>
                            <CostumePanel vm={this.props.vm} />
                        </TabPanel>
                        <TabPanel className={tabClassNames.tabPanel}>
                            <SoundPanel vm={this.props.vm} />
                        </TabPanel>
                    </Tabs>
                </Box>
            </Modal>
        );
    }
}

LibraryComponent.propTypes = {
    id: PropTypes.string.isRequired,
    onRequestClose: PropTypes.func,
    vm: PropTypes.instanceOf(VM).isRequired
};

LibraryComponent.defaultProps = {
    activeTabIndex: 0
};

export default injectIntl(LibraryComponent);
